// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-filter-bar',
    // #endregion
    // #region Properties
    props: {
        filters: {
            type: Array,
            required: false,
            default() {
                return [];
            }
        },
    },
    data: () => ({
        isLoading: false,
    }),
    // #endregion
    // #region Constructor
    created() {
    },
    // #endregion
    // #region Core
    methods: {
        toogleButton(filter) {
            filter.isOpen = !filter.isOpen;
        },
        closeButton(filter) {
            filter.isOpen = false;
        },
        selectedCount(filter) {
            let tItem = 0;
            if (filter.values) {
                filter.values.forEach((e) => {
                    if (e.applied) {
                        tItem = tItem + 1;
                    }
                });
            }
            return tItem;
        },
        onFilterApply(filter, select) {
            //new
            let tQuery = Object.assign({}, this.$route.query);
            //Set
            if (select.length == 0) {
                delete tQuery[filter.urlKey];
            }
            else {
                tQuery[filter.urlKey] = select.join('.');
            }
            //Reset
            delete tQuery["p"];
            this.$router.replace({ query: tQuery });
        },
    }
    // #endregion
});
// #endregion
